module.exports = __webpack_public_path__ + "assets/img/4debfb5c7f3fe49aba307e5240dca0be.svg";